import { Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import axios from "axios";

function Viewordercolordetails({ Sub_Order_id }) {
    const url = localStorage.getItem("url");
    const [suborder, setsuborder] = useState({});

    useEffect(() => {
        fetchsuborder();
    }, []);

    const fetchsuborder = async () => {
        try {
            const response = await axios.get(`order/suborders_by_suborder_id/${Sub_Order_id}`);
            const SubOrderData = response.data.suborder;
            setsuborder(SubOrderData);
        } catch (error) {
            console.error("Error fetching suborders_by_suborder_id  data:", error);
        }
    };

    const sizeVariantKeys = suborder.length > 0 ? Object.keys(suborder[0]?.size_variant_quantity || {}) : [];

    // Custom sort order for Type 1
    const sizeOrder = ['S', 'M', 'L', 'XL', 'XXL'];

    // Custom sort function for Type 1
    const sortType1 = (a, b) => {
        return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
    };

    // Custom sort function for Type 2
    const sortType2 = (a, b) => {
        const numA = parseInt(a, 10);
        const numB = parseInt(b, 10);

        // Compare numbers first, then handle suffixes (FS, HS)
        if (numA !== numB) return numA - numB;

        // If numbers are equal, compare suffixes
        return a.localeCompare(b);
    };

    // Sort the array based on the type of values
    const sortedSizeVariantKeys = sizeVariantKeys.sort((a, b) => {
        if (a.includes('FS') || a.includes('HS')) {
            // Type 2: Sort based on numeric and suffix logic
            return sortType2(a, b);
        } else {
            // Type 1: Sort based on predefined order (S, M, L, XL, XXL)
            return sortType1(a, b);
        }
    });

    console.log(sortedSizeVariantKeys);


    return (
        <>
            <div className="overflow-x-auto ">
                <Table className="w-full text-center">
                    <Table.Head className="border">
                        <Table.HeadCell className="border min-w-[40px] max-w-[40px] text-center">Colour</Table.HeadCell>
                        {sizeVariantKeys.map((key) => (
                            <Table.HeadCell key={key} className="border">
                                {key}
                            </Table.HeadCell>
                        ))}
                        <Table.HeadCell className="border">Total</Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y">
                        {suborder.length > 0 &&
                            suborder.map((sub) => (
                                <Table.Row key={sub.sub_order_id} className="bg-white">
                                    {/* <Table.Cell className="border min-w-[25px] max-w-[25px]">
                                        <div className="flex items-center space-x-2">
                                            <div className="flex items-center justify-center">
                                                <img
                                                    src={`${url}${sub.colour_image}`}
                                                    alt={sub.colour_name}
                                                    className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                                                />
                                            </div>
                                            <span>{sub.colour_name}</span>
                                        </div>
                                    </Table.Cell> */}
                                    <Table.Cell className="border align-top p-1 " >
                                        <div className="w-[60px] mx-auto ">
                                            <img
                                                src={`${url}${sub.colour_image}`}
                                                alt={sub.colour_name}
                                                className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md mb-1 mx-auto"
                                            />
                                            <div className="text-[10px] text-jutify break-words whitespace-normal leading-tight ">
                                                {sub.colour_name}
                                            </div>
                                        </div>
                                    </Table.Cell>








                                    {sizeVariantKeys.map((key) => (
                                        <Table.Cell key={key} className="border">
                                            {sub.size_variant_quantity[key] || ""}
                                        </Table.Cell>
                                    ))}

                                    <Table.Cell className="border">{sub.total_piece}</Table.Cell>
                                </Table.Row>
                            ))}
                    </Table.Body>
                </Table>
            </div>

        </>
    );
};

export default Viewordercolordetails;